import ExtraSmallNewsCard from '@pickleballinc/features/src/hub-cards/ExtraSmallNewsCard/ExtraSmallNewsCard';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import { Fragment } from 'react';

import { publicEnv } from '@/lib/env';
import { RenderSideNewsInterface } from '@/utils/actions/homepage/getNewsByUuids';

export interface RenderSideNewsProps {
  title: string;
  news: RenderSideNewsInterface[];
}

export const RenderSideNews = ({ title, news }: RenderSideNewsProps) => {
  if (news.length === 0) return null;

  return (
    <div className='flex w-full flex-col rounded-lg bg-white shadow-sm'>
      <h2 className='flex h-[52px] w-full items-center border-b border-solid border-gray-200 ps-4 text-left text-sm font-bold leading-5 tracking-normal'>
        {title}
      </h2>
      <div className='flex w-full flex-col gap-4 px-3 py-4'>
        {news.map((newsObj, index) => {
          const newsURL = `https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}/${newsObj.categorySlug}/${newsObj.slug}`;
          return (
            <Fragment key={newsObj.slug}>
              <CustomLink
                className='hover:opacity-80'
                href={`/${newsObj.categorySlug}/${newsObj.slug}`}
              >
                <ExtraSmallNewsCard
                  url={newsURL}
                  description={newsObj.description}
                  image={newsObj.imageUrl}
                  imageAltText={newsObj.imageAltText}
                  title={newsObj.title}
                  author={newsObj.authorFullName}
                  publishDateDisplayed={newsObj.publishDateDisplayed}
                />
              </CustomLink>
              {index !== news.length - 1 && (
                <div className='flex justify-center'>
                  <div className='flex w-[274px] content-center items-center justify-center self-center border-b border-solid border-gray-200' />
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
